import script from "./BlogCategoriesList.vue?vue&type=script&setup=true&lang=js"
export * from "./BlogCategoriesList.vue?vue&type=script&setup=true&lang=js"

import "./BlogCategoriesList.vue?vue&type=style&index=0&id=3af348f7&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3af348f7"]])

export default __exports__